import React from 'react';
import type { BlockBenefitsOfMMC } from 'types/block-benefits-of-mmc';

import Image from 'next/image';
import { Paragraph, Wrap } from '@leafwell/components';

import HeadingBody from './heading-body';

const BenefitCard: React.FC<{
  title?: string;
  description?: string;
  imagePath?: string;
  filled?: boolean;
}> = ({ title, imagePath, filled }) => {
  return (
    <li
      className={[
        'flex md:flex-col items-center justify-start gap-6 lg:gap-4 border border-lilac-300 rounded-lg px-6 py-2 lg:p-4 w-full lg:w-[300px] lg:h-[200px]',
        filled ? 'bg-lilac-50' : 'bg-white',
      ].join(' ')}
    >
      <Image src={imagePath} alt="" height={70} width={70} className="" />
      <Paragraph
        className="text-left md:text-center font-semibold"
        size="large"
        tagName="h3"
        dangerouslySetInnerHTML={{ __html: title }}
      />
    </li>
  );
};

const BenefitsOfMMC: React.FC<BlockBenefitsOfMMC> = ({
  sectionId,
  title,
  description,
  accessToDispensaries,
  taxSavings,
  cultivation,
  higherPossession,
  accessToProducts,
  lowerAgeRestriction,
  legalProtection,
}) => {
  return (
    <Wrap id={sectionId} className="justify-items-center">
      {title || description ? (
        <div className="grid gap-y-6 justify-items-center">
          {title && (
            <HeadingBody
              level="2"
              tagName="h2"
              title={title}
              className="font-semibold text-center"
            />
          )}
          {description && (
            <Paragraph
              dangerouslySetInnerHTML={{ __html: description }}
              size="large"
              className="text-center lg:max-w-5xl"
            />
          )}
        </div>
      ) : null}
      <ul className="flex flex-wrap items-start justify-start md:justify-center gap-6">
        {accessToDispensaries?.description ? (
          <BenefitCard
            title={accessToDispensaries?.title}
            //description={accessToDispensaries?.description}
            imagePath="/access-dispensaries-orange.svg"
            filled={accessToDispensaries?.highlight}
          />
        ) : null}
        {taxSavings?.description ? (
          <BenefitCard
            title={taxSavings?.title}
            //description={taxSavings?.description}
            imagePath="/tax-savings-yellow.svg"
            filled={taxSavings?.highlight}
          />
        ) : null}
        {legalProtection?.description ? (
          <BenefitCard
            title={legalProtection?.title}
            //description={legalProtection?.description}
            imagePath="/legal-protection-purple.svg"
            filled={legalProtection?.highlight}
          />
        ) : null}
        {accessToProducts?.description ? (
          <BenefitCard
            title={accessToProducts?.title}
            //description={accessToProducts?.description}
            imagePath="/quality-products-green.svg"
            filled={accessToProducts?.highlight}
          />
        ) : null}
        {lowerAgeRestriction?.description ? (
          <BenefitCard
            title={lowerAgeRestriction?.title}
            //description={lowerAgeRestriction?.description}
            imagePath="/age-possession-red.svg"
            filled={lowerAgeRestriction?.highlight}
          />
        ) : null}
        {cultivation?.description ? (
          <BenefitCard
            title={cultivation?.title}
            //description={cultivation?.description}
            imagePath="/cultivation-blue.svg"
            filled={cultivation?.highlight}
          />
        ) : null}
        {higherPossession?.description ? (
          <BenefitCard
            title={higherPossession?.title}
            //description={higherPossession?.description}
            imagePath="/higher-possession-pink.svg"
            filled={higherPossession?.highlight}
          />
        ) : null}
      </ul>
    </Wrap>
  );
};

export default BenefitsOfMMC;
